import { SelectModule } from "./../select/select.module";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PaginatorComponent } from "./paginator.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TransitionModule } from "../transition/transition.module";
import { IconModule } from "../icon/icon.module";

@NgModule({
	declarations: [PaginatorComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TransitionModule, IconModule, SelectModule],
	exports: [PaginatorComponent]
})
export class PaginatorModule { }
